import React, { Component } from "react";
import { Table, Input, Select, Button, Tooltip } from "antd";
import {
  getNowAcademicYear,
  getNowAcademicSemester,
} from "../../utils/dateUtil";
import { req_list_lrs_finishByFulltime_history } from "../../api";
import storageUtils from "../../utils/storageUtils";

export default class HistoryFinishByFulltime extends Component {
  // 基礎通用參數 //////////////////////////////////////////////

  state = {
    items: [],
    nowAcademicYear: getNowAcademicYear(new Date()),
    nowAcademicSemester: getNowAcademicSemester(new Date()),
  };

  UNSAFE_componentWillMount() {
    this.api_list_items();
    this.init_columns();
  }

  // 遠端數據處理 //////////////////////////////////////////////

  api_list_items = async () => {
    this.setState({ loading: true });
    const {nowAcademicYear, nowAcademicSemester} = this.state;
    const result = await req_list_lrs_finishByFulltime_history(
      nowAcademicYear,
      nowAcademicSemester,
      storageUtils.getUser().token
    );
    this.setState({ loading: false });

    //console.log(result)
    if (result.total > 0) {
      const items = result.data;
      this.setState({ items });
    }
  };

  // 數據配置設定 //////////////////////////////////////////////

  init_columns = () => {
    this.columns = [
      {
        title: "學年度",
        dataIndex: "academicYear",
        width: 20,
      },
      {
        title: "學期",
        dataIndex: "academicSemester",
        width: 20,
      },
      {
        title: "專兼任分類",
        dataIndex: "timeType",
        width: 60,
      },
      {
        title: "專兼任課程總數",
        dataIndex: "timeTypeTotal",
        width: 30,
        render: (timeTypeTotal) => <>{timeTypeTotal}門</>,
      },
      {
        title: "已完成教材上傳課程數",
        dataIndex: "hasMaterialTotal",
        width: 30,
        render: (hasMaterialTotal) => <>{hasMaterialTotal}門</>,
      },
      {
        title: "完成率",
        dataIndex: "sumTotal",
        width: 65,
        render: (sumTotal) => <>{sumTotal}%</>,
      },
    ];
  };

  ////////////////////////////////////////////////////////////

  render() {
    const { items, nowAcademicYear, nowAcademicSemester } = this.state;
    const title = (
      <>
        <span>
          <Input
            placeholder="學年度"
            style={{
              width: 80,
              margin: "0 5px",
              backgroundColor: "LightYellow",
            }}
            value={nowAcademicYear}
            onChange={(event) =>
              this.setState({ nowAcademicYear: event.target.value })
            }
          />
          <Select
            value={nowAcademicSemester}
            style={{ width: 120, backgroundColor: "LightCyan" }}
            onChange={(value) => this.setState({ nowAcademicSemester: value })}
          >
            <Select.Option value="1">上學期</Select.Option>
            <Select.Option value="2">下學期</Select.Option>
          </Select>
          <Button type="primary" onClick={() => this.api_list_items()}>
            <i className="fas fa-search element-hidden"></i>
            <span style={{ marginLeft: "4px" }}>查詢</span>
          </Button>{" "}
          <Tooltip placement="top" title="重新整理">
            <Button type="primary" onClick={() => this.api_list_items()}>
              <i className="fas fa-sync-alt"></i>
            </Button>
          </Tooltip>{" "}
        </span>
      </>
    );
    return (
      <>
        {title}
        <Table
          scroll={{ y: 480 }}
          dataSource={items}
          columns={this.columns}
          pagination={false}
          rowKey="timeType"
        />
      </>
    );
  }
}
